import { useState, useEffect } from 'react';
import { ref as dbRef, onValue } from 'firebase/database';
import { database } from '../config/firebase';

/**
 * usePlanFeatures — Fase 9 del piano.
 *
 * Legge plans/{planId} per sapere quali funzionalità sono incluse nel piano
 * corrente dell'azienda (codiciSconto, statisticheAvanzate, dominioPersonalizzato,
 * personalizzazioneApp, maxVehicles, maxStorageGB, ecc.) — fonte unica di verità
 * condivisa con le Firebase Rules (che leggono lo stesso nodo per i limiti numerici).
 *
 * Da usare per NASCONDERE funzionalità non incluse nel piano in UI — l'enforcement
 * reale dei limiti numerici resta nelle Rules (Fase 1/9), questo hook serve solo
 * a non mostrare all'utente controlli che finirebbero comunque rifiutati.
 */
export function usePlanFeatures(planId) {
  const [features, setFeatures] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!planId) {
      setFeatures(null);
      setLoading(false);
      return;
    }

    const planRef = dbRef(database, `plans/${planId}`);
    const unsubscribe = onValue(
      planRef,
      (snapshot) => {
        setFeatures(snapshot.val() || null);
        setLoading(false);
      },
      (err) => {
        // BUG FIX: senza questo callback, un errore di lettura (es. rete
        // assente/instabile) lasciava 'loading' bloccato a true per sempre,
        // perché né il callback di successo né uno di errore venivano mai
        // invocati. Il nodo è a lettura pubblica quindi non è un problema di
        // permessi, ma di robustezza in caso di connettività instabile.
        console.error('Errore caricamento piano:', err);
        setFeatures(null);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [planId]);

  return { features, loading };
}
